// Product Addon

function toggleCart(variantId, button) {
  if (button.textContent === "+ Add") {
    addToCart(variantId, button);
  } else {
    removeFromCart(variantId, button);
  }
}

function addToCart(variantId, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "Added";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeFromCart(variantId, button) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "+ Add";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Footer Country Selector

document.addEventListener("DOMContentLoaded", function () {
  var usFlagLink = document.getElementById("flag");
  if (usFlagLink) {
    usFlagLink.addEventListener("click", function (event) {
      event.preventDefault();
    });
  }
});

// Infinite Addons quantity matcher
$(document).ready(function () {
  $('input[name="quantity"]').on("change", function () {
    var quantity = $(this).val(); // Get the product quantity

    $('select[name="addon_field"], input[name="addon_field"]').each(
      function () {
        var addonField = $(this);
        addonField.attr("data-quantity", quantity);
      }
    );
  });
});

// Fix Slider Buttons
$(document).ready(function () {
  // Fix featured collection slider buttons
  $(document).on(
    "click",
    ".featured-collection-controls .prev, .featured-collection-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest(
        '[data-section-type="featured-collection"]'
      );
      var $slider = $("[data-carousel-enabled]", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  // Fix slideshow buttons
  $(document).on(
    "click",
    ".full-width-slideshow-controls .prev, .full-width-slideshow-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="slideshow"]');
      var $slider = $(".js-slideshow-section", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  // Fix gallery buttons
  $(document).on(
    "click",
    ".gallery-controls .prev, .gallery-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="gallery"]');
      var $slider = $(".js-gallery-slider", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );
});

// Back in stock
const soldOutVariants = JSON.parse(
  document.getElementById("sold-out-variants-json").textContent
);
const productVariants = JSON.parse(
  document.getElementById("product-variants-json").textContent
);
const productData = JSON.parse(
  document.getElementById("product-data-json").textContent
);

const variantInput = document.querySelector('input[name="id"]');
const formWrapper = document.getElementById("back-in-stock-wrapper");
const tagsInput = document.getElementById("back-in-stock-tags");
const noteInput = document.getElementById("back-in-stock-note");
const variantDropdowns = document.querySelectorAll(
  ".option-selector[data-single-option-selector]"
);

function getCurrentVariantObject() {
  const variantId = variantInput.value;
  return productVariants.find((v) => String(v.id) === variantId);
}

function buildTagsFromVariant(variant) {
  const tags = ["back_in_stock", `bis_product_${productData.handle}`];

  variant.options.forEach((optionValue, index) => {
    tags.push(
      `bis_option${index + 1}_${optionValue.replace(/\s+/g, "-").toLowerCase()}`
    );
  });

  return tags.join(",");
}

function updateBackInStockForm() {
  if (!variantInput || !formWrapper) return;

  const variantId = variantInput.value;
  const currentVariant = getCurrentVariantObject();

  if (!currentVariant) return;

  if (soldOutVariants.includes(Number(variantId))) {
    formWrapper.style.display = "block";

    tagsInput.value = buildTagsFromVariant(currentVariant);
    noteInput.value = `Back-in-stock signup → ${productData.title} • ${currentVariant.title} (ID ${variantId})`;
  } else {
    formWrapper.style.display = "none";
  }
}

variantDropdowns.forEach((dropdown) => {
  dropdown.addEventListener("change", updateBackInStockForm);
  dropdown.addEventListener("click", updateBackInStockForm);
});

updateBackInStockForm();
